module.exports = __webpack_public_path__ + "static/sport/bgi-tag-right-active.6f9d28a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/bgi-tag-right-active.png
// module id = RZlV
// module chunks = 0